import { render, staticRenderFns } from "./imgClassifyDialog.vue?vue&type=template&id=280843f2&scoped=true"
import script from "./imgClassifyDialog.vue?vue&type=script&lang=js"
export * from "./imgClassifyDialog.vue?vue&type=script&lang=js"
import style0 from "./imgClassifyDialog.vue?vue&type=style&index=0&id=280843f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280843f2",
  null
  
)

export default component.exports